import type { UIMessage } from "ai";

/**
 * Replace a failed turn, including any partial streamed assistant output, with
 * its retryable error message while preserving the user message that began it.
 */
export function replaceFailedSimulationTurn(
  messages: readonly UIMessage[],
  errorMessage: UIMessage,
): UIMessage[] {
  const lastUserMessageIndex = messages.findLastIndex(
    (message) => message.role === "user",
  );
  return [...messages.slice(0, lastUserMessageIndex + 1), errorMessage];
}
